import React from "react";

import onChangePrice from "helpers/onChangePrice";
import onChangeNumber from "helpers/onChangeNumber";

const FormDetailDanBudget = ({ control, Controller, property_type_id, optionUnitPrice, listing_type_id }) => {
  return (
    <div>
      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Luas Tanah (min.)
        </p>
        <Controller
          name="min_surface_area"
          control={control}
          render={({ field }) => (
            <div className="w-[calc(100%-126px)] flex justify-between items-center gap-1 p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
              <input
                {...field}
                type="text"
                onChange={(e) => onChangeNumber(e, field.onChange)}
                value={field.value}
                className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#D8D8D9]"
                placeholder="0"
              />

              <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#808285]">
                m<sup>2</sup>
              </span>
            </div>
          )}
        />
      </div>

      {property_type_id !== 4 && <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Luas Bangunan (min.)
        </p>
        <Controller
          name="min_building_area"
          control={control}
          render={({ field }) => (
            <div className="w-[calc(100%-126px)] flex justify-between items-center gap-1 p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
              <input
                {...field}
                type="text"
                onChange={(e) => onChangeNumber(e, field.onChange)}
                value={field.value}
                className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#D8D8D9]"
                placeholder="0"
              />

              <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#808285]">
                m<sup>2</sup>
              </span>
            </div>
          )}
        />
      </div>}

      <div className="flex items-start gap-2 py-2 w-full">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Budget
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <div className="w-[calc(100%-126px)]">
          <Controller
            name="min_price"
            control={control}
            
            render={({ field }) => (
              <div className="mb-[12px] w-full flex justify-between items-center gap-1 p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
                <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#808285]">
                  Rp
                </span>

                <input
                  {...field}
                  onChange={(e) => onChangePrice(e, field.onChange)}
                  value={field.value}
                  type="text"
                  className="w-full text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#D8D8D9]"
                  placeholder="minimal"
                />
              </div>
            )}
          />
          <Controller
            name="max_price"
            control={control}
            render={({ field }) => (
              <div className="mb-[12px] w-full flex justify-between items-center gap-1 p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
                <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#808285]">
                  Rp
                </span>

                <input
                  {...field}
                  onChange={(e) => onChangePrice(e, field.onChange)}
                  value={field.value}
                  type="text"
                  className="w-full text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#D8D8D9]"
                  placeholder="maksimal"
                />
              </div>
            )}
          />
          {listing_type_id === 2 && <Controller
            name="unit_price_id"
            control={control}
            render={({ field }) => (
              <div className="w-full relative">
                <select
                  {...field}
                  className="w-full text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] appearance-none bg-white pr-8"
                >
                  <option value="">Pilih Durasi</option>
                  {optionUnitPrice.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#252526" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            )}
          />}
        </div>
      </div>

      {property_type_id === 2 && <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]"></p>
        <Controller
          name="is_studio"
          control={control}
          render={({ field }) => (
            <label className="flex items-center gap-2 cursor-pointer">
              <div className="relative">
                <input
                  type="checkbox"
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  className="sr-only peer"
                />
                <div className="w-5 h-5 border-[1px] border-solid border-[#D8D8D9] rounded-[4px] peer-checked:bg-[#02AC5B] peer-checked:border-[#02AC5B] flex items-center justify-center">
                  {field.value && (
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 5L4.5 8.5L11 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
              <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
                Tipe Studio
              </span>
            </label>
          )}
        />
      </div>}

      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Kamar Tidur (min.)
        </p>
        <Controller
          name="bedroom"
          control={control}
          render={({ field }) => (
            <input
              {...field}
              onChange={(e) => onChangeNumber(e, field.onChange)}
              value={field.value}
              type="text"
              className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] w-[calc(100%-126px)] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] placeholder:text-[#D8D8D9]"
              placeholder="0"
            />
          )}
        />
      </div>
      
      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Kamar Mandi (min.)
        </p>
        <Controller
          name="bathroom"
          control={control}
          render={({ field }) => (
            <input
              {...field}
              onChange={(e) => onChangeNumber(e, field.onChange)}
              value={field.value}
              type="text"
              className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] w-[calc(100%-126px)] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] placeholder:text-[#D8D8D9]"
              placeholder="0"
            />
          )}
        />
      </div>
    </div>
  );
};

export default FormDetailDanBudget;
